import { IRefreshTokenResponse } from 'src/app/core/interfaces/sso.interface';

export class SsoVerifyTokenAction {
  static readonly type = '[SSO] Verify Token';
  constructor(public payload: IRefreshTokenResponse) {}
}

export class SsoRefreshTokenAction {
  static readonly type = '[SSO] Refresh Token';
  constructor(public payload: string) {}
}

export class SsoLogoutAction {
  static readonly type = '[SSO] Logout';
  constructor(public payload: any) {}
}

export class SsoClearStateAction {
  static readonly type = '[SSO] Clear State';
  constructor() {}
}

export class SsoSetUserInfoAction {
  static readonly type = '[SSO] Set User Info';
  constructor(
    public payload: any,
    public skipVerification?: boolean
  ) {}
}

export class SsoResetUserInfo {
  static readonly type = '[SSO] Reset User Info';
  constructor() {}
}

export class SetUserInfoAction {
  static readonly type = '[SSO] Set User Info';
  constructor(public payload: IRefreshTokenResponse) {}
}
